import { _ as r } from "../internals/export.js";
import { c as t } from "../internals/create-html.js";
import { s } from "../internals/string-html-forced.js";
r({
  target: "String",
  proto: !0,
  forced: s("strike")
}, {
  strike: function strike() {
    return t(this, "strike", "", "");
  }
});